<template>
  <div id="contenedor-main-listado">
    <skeleton-reporte v-if="cargando" tipo="listado" mensaje="Cargando reportes registrados…" />
    <template v-else-if="!$vuetify.breakpoint.xs">
      <desktop desktop :reportesFisicos="getReportesFisicos" :programaContrato="programaContrato" />
    </template>
    <template v-else>
      <mobile :reportesFisicos="getReportesFisicos" />
    </template>
  </div>
</template>

<script>
import SkeletonReporte from '@/components/administracion/ejecucion/reportes/documento/SkeletonReporte.vue';
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListado',
  components: {
    SkeletonReporte,
    Desktop,
    Mobile,
  },
  props: {
    reportesFisicos: Array,
    cargando: { type: Boolean, default: false },
    programaContrato: {
      type: [Object, Array],
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    getReportesFisicos() {
      if (!this.reportesFisicos) return [];
      return this.reportesFisicos;
    },
  },
};
</script>

<style lang="scss">

</style>
